import classNames from "classnames";
import { CSSProperties, HTMLAttributes, ReactNode } from "react";
import styles from "./style.module.scss";

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  text: string;
  textStyleType: "semiBold" | "regular";
  disabled?: boolean;
  style: CSSProperties;
  iconDirection?: "left" | "right";
  renderIcon?: () => ReactNode;
  type?: "button" | "submit";
}

export const Button = ({
  text,
  textStyleType,
  disabled = false,
  style = {},
  renderIcon,
  iconDirection,
  onClick,
  type,
}: ButtonProps) => {
  return (
    <div className={styles.wrapper}>
      {iconDirection === "left" && renderIcon ? renderIcon() : null}
      <button
        type={type}
        style={style}
        disabled={disabled}
        className={classNames(
          styles.button,
          textStyleType === "semiBold"
            ? styles.buttonBold
            : styles.buttonRegular,
        )}
        onClick={onClick}
      >
        {text}
      </button>
      {iconDirection === "right" && renderIcon ? renderIcon() : null}
    </div>
  );
};
